"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLanguageDirection = exports.getJavaLocale = exports.normalizeLocale = exports.getLocale = exports.DEFAULT_LOCALE = void 0;
var GlobalConfig_1 = require("./GlobalConfig");
var URLUtils_1 = require("./URLUtils");
exports.DEFAULT_LOCALE = 'en-us';
/**
 * Return the current locale value in the format [language code]-[country code]; i.e. en-us.
 *
 * The locale is resolved in the following order; first valid value found is used:
 *
 * - The URL `debugLocale` parameter
 * - The global config object
 * - The global i18n object
 *
 * If unable to determine the current locale, the default locale of 'en-us' is returned.
 *
 * @returns Current locale
 */
exports.getLocale = function () {
    var _a, _b;
    var debugLocale = URLUtils_1.getURLParameters().debugLocale;
    var contextLocale = GlobalConfig_1.getGlobalConfigContext().locale;
    var i18nLocale = typeof window !== 'undefined' && ((_b = (_a = window.EPC) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b.locale);
    var locale = debugLocale || contextLocale || i18nLocale || exports.DEFAULT_LOCALE;
    return exports.normalizeLocale(locale);
};
/**
 * Provides a standardized formatting for a locale string. The formatted
 * string will be lower-case, with the two-letter ISO language code,
 * then a hyphen, then the ISO country code.  For example, `en-us`.
 *
 * @param locale Locale string to normalize.
 */
exports.normalizeLocale = function (locale) {
    if (!/[A-Z]{2}(-|_)[A-Z]{2}/i.test(locale)) {
        throw new Error("Invalid locale: " + locale);
    }
    return locale.trim().replace('_', '-').toLowerCase();
};
/**
 * Formats a locale string as a Java locale.  This is useful when working with a normalized locale
 * string format ll-cc (e.g. de-at), but there is a need for locale format interop with Java.  This is the case
 * for looking up localized messages from the global (injected into most apps via JSP tag) which keys
 * data by locale in the ll_CC (e.g. de_AT) format.
 *
 * @param locale The locale to convert to Java locale format.
 */
exports.getJavaLocale = function (locale) {
    var pattern = /[a-z]{2}_[A-Z]{2}/;
    if (pattern.test(locale)) {
        return locale;
    }
    var parts = locale.split(/-|_/);
    var language = parts[0] && parts[0].toLowerCase();
    var country = parts[1] && parts[1].toUpperCase();
    var javaLocale = language + "_" + country;
    if (pattern.test(javaLocale)) {
        return javaLocale;
    }
    throw new Error("Unable to create a Java formatted locale string from src locale: " + locale);
};
/**
 * Get the current language direction associated with the current locale as specified in
 * the `dir` attribute of the body tag.  If the `dir` attribute is not available, the default
 * direction, "ltr", is returned.
 */
exports.getLanguageDirection = function () {
    var defaultDirection = 'ltr';
    if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
        return window.document.documentElement.getAttribute('dir') || defaultDirection;
    }
    return defaultDirection;
};
